import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class LgService {

  getServiceRepair(pat_id) {
    let headers = authHeader();
    return axios
      .post(`${config["apiUrl"]}service-lg/service-repair`, { pat_id: pat_id }, {
        headers: headers
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this.handleError(error);
        throw error;
      });
  }

  /**
   * Envia ficheiro para a LG (via Backend Laravel)
   * @param {Object} bodyParms - { file: {filepath: '...'}, origin_reference: '...', lg_file_type: '...' }
   */
  addFile(bodyParms) {
    let headers = authHeader();
    return axios
      .post(`${config["apiUrl"]}service-lg/add-file`, bodyParms, {
        headers: headers
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this.handleError(error);
        throw error;
      });
  }

  /**
   * Atualiza dados da reparação na LG
   * @param {Object} bodyParms - { pat_id: 1, rne: '...', status: '...', parts: [] }
   */
  updateRepair(bodyParms) {
    let headers = authHeader();
    return axios
      .post(`${config["apiUrl"]}service-lg/update-repair`, bodyParms, {
        headers: headers
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this.handleError(error);
        throw error;
      });
  }

  updateStatus(bodyParms) {
    let headers = authHeader();
    return axios
      .post(`${config["apiUrl"]}service-lg/update-status`, bodyParms, {
        headers: headers
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this.handleError(error);
        throw error;
      });
  }

  completeRepair(bodyParms) {
    let headers = authHeader();
    return axios
      .post(`${config["apiUrl"]}service-lg/complete-repair`, bodyParms, {
        headers: headers
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this.handleError(error);
        throw error;
      });
  }

  handleError(error) {
    if (error.response) {
        if (error.response.status === 401) {
            AuthService.logout();
            window.location = "/login";
        }
    }
  }

  getGroupedConfigCodes() {
    let headers = authHeader();
    return axios
      .get(`${config["apiUrl"]}service-lg/config/codes-grouped`, {
        headers: headers
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this.handleError(error);
        throw error;
      });
  }

  refreshFromLg(pat_id) {
    let headers = authHeader();
    return axios
      .post(`${config["apiUrl"]}service-lg/refresh-from-lg`, { pat_id: pat_id }, {
        headers: headers
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this.handleError(error);
        throw error;
      });
  }

  validateModelNo(modelNo) {
    let headers = authHeader();
    return axios
      .post(`${config["apiUrl"]}service-lg/validate-model-no`, { model_no: modelNo }, {
        headers: headers
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this.handleError(error);
        throw error;
      });
  }

  retrievePartOrderStatus(invoiceNo) {
    let headers = authHeader();
    return axios
      .post(`${config["apiUrl"]}service-lg/retrieve-part-order-status`, { invoice_no: invoiceNo }, {
        headers: headers
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this.handleError(error);
        throw error;
      });
  }

  retrieveInvoiceNumber(partNo, startDate = null) {
    let headers = authHeader();
    let body = { part_no: partNo };
    if (startDate) {
      body.start_date = startDate;
    }
    return axios
      .post(`${config["apiUrl"]}service-lg/retrieve-invoice-number`, body, {
        headers: headers
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this.handleError(error);
        throw error;
      });
  }

  validateSerialNumber(serialNumber) {
    let headers = authHeader();
    return axios
      .post(`${config["apiUrl"]}service-lg/validate-serial-number`, { serial_number: serialNumber }, {
        headers: headers
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this.handleError(error);
        throw error;
      });
  }

  getConfigCodes(code) {
    let headers = authHeader();
    return axios
      .get(`${config["apiUrl"]}service-lg/config/codes/${code}`, {
        headers: headers
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this.handleError(error);
        throw error;
      });
  }

  updateConfigCodes(codesPayload) {
    let headers = authHeader();
    return axios
      .post(`${config["apiUrl"]}service-lg/config/codes`, codesPayload, {
        headers: headers
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this.handleError(error);
        throw error;
      });
  }
}

export default new LgService();